module.exports = __webpack_public_path__ + "static/assets/9af03b54180d471ac76be42fcdb37a15.svg";